import { render, staticRenderFns } from "./FeeDialog.vue?vue&type=template&id=481f18cc&"
import script from "./FeeDialog.vue?vue&type=script&lang=js&"
export * from "./FeeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports